import { Injectable } from "@angular/core";
import { of } from "rxjs";

@Injectable()
export class ThoughtworksDemoService {

    constructor() {

    }

    getDemos() {
        return of([
            {
                id: 3,
                title: "How to Scout and Scope a Data Product",
                description: `Thoughtworks delivers a training on how to scout and scope a data product. This training session covers the following:
<ul>
<li>  Learn the do’s/don’ts of running business requirement workshops</li>
<li>  Practice the skills necessary to capture business and technical requirements for a data product</li>
<li>  Individual Q&A/Mentoring for Product Owners, Squad Leads (Reserved to: Last 30 minutes)</li>
</ul>`,
                duration: "01:03:20 ",
                recordedDate: "Mar 27, 2024",
                videoUrl: "VIDEO_PLACEHOLDER",
            },
            {
                id: 2,
                title: "Deep Dive for Data Products on UDF",
                description: `Thoughtworks conducts an interactive Q&A on their modern data architecture and build approach for Wells data products. This Q&A session covers the following:
<ol>
<li>Show and tell the changes to build/delivering data products on UDF platform</li>
<li>Details on THHC data products – from a UDF platform/infrastructure</li>
<li>Q&A for XOM Data Engineers to ask Thoughtworks about the steps/processes/code to build the products</li>
</ol>`,
                duration: "00:43:25",
                recordedDate: "Feb 28, 2024",
                videoUrl: "VIDEO_PLACEHOLDER"
            },
            {
                id: 1,
                title: "Reference Data Mesh Platform Interactive Demo",
                description: `Thoughtworks performs a live demo of their data mesh platform on Azure in
which they upskill and practice building data products. The demo will walk.
through the necessary steps of provisioning infrastructure and the data.
pipeline.`,
                duration: "01:30:00",
                recordedDate: "Jan 31, 2024",
                videoUrl: "VIDEO_PLACEHOLDER"
            },
            {
                id: 4,
                title: "Understanding Modern Data Engineering and Architecture.",
                description: `Explore trends in the market, the shift in the data landscape, and the key principles and practices that define modern data engineering and architecture.  We will discuss the tradeoffs involved in making architectural choices, applying modern software engineering practices to data.`,
                duration: "01:30:00",
                recordedDate: "Aug 8, 2024",
                videoUrl: "VIDEO_PLACEHOLDER",
            },
            {
                id: 5,
                title: "Data Product Deployment Tracker Demo",
                description: `The Upstream Data Product Deployment Tracker will complement Collibra by providing relevant, shareable Data Product information that will enable Upstream teams to be informed about Upstream Data Product Deployments.`,
                duration: "01:30:00",
                recordedDate: "Jan 22, 2025",
                videoUrl: "VIDEO_PLACEHOLDERx",
            },
        ])
    }
}
